import { apiClient, isSupabaseConfigured } from './_shared.js'

// ============================================
// STORAGE (Фотодоказательства)
// ============================================

export async function uploadEvidenceFile(file) {
  if (!isSupabaseConfigured) {
    console.warn('Демо-режим: Файл не загружен')
    return null
  }

  const formData = new FormData()
  formData.append('file', file)

  const token = localStorage.getItem('token')
  const API_URL = import.meta.env.VITE_API_URL || '/api'
  
  const response = await fetch(`${API_URL}/upload/evidence`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: formData
  })
  
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Ошибка загрузки файла')
  }
  
  const data = await response.json()
  return data.url
}

// ============================================
// STORAGE (Аватарки)
// ============================================

export async function uploadAvatar(file, employeeId) {
  if (!isSupabaseConfigured) {
    console.warn('Демо-режим: Аватарка не загружена')
    return null
  }

  const maxSize = 5 * 1024 * 1024 // 5 MB
  if (file.size > maxSize) {
    throw new Error('Размер файла не должен превышать 5 МБ.')
  }
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp']
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Поддерживаются только форматы JPG, PNG и WEBP.')
  }

  const formData = new FormData()
  formData.append('file', file)
  if (employeeId) formData.append('employeeId', employeeId)

  const token = localStorage.getItem('token')
  const API_URL = import.meta.env.VITE_API_URL || '/api'
  
  const response = await fetch(`${API_URL}/upload/avatar`, {
    method: 'POST',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: formData
  })
  
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Ошибка загрузки аватара')
  }
  
  const data = await response.json()
  return data.url
}

export async function updateProfileAvatar(employeeId, avatarUrl) {
  return await apiClient(`/employees/${employeeId}`, {
    method: 'PUT',
    body: JSON.stringify({ avatar_url: avatarUrl })
  })
}
